import { render } from "./KeyWordsToValueView.vue?vue&type=template&id=2e026768&scoped=true&ts=true"
import script from "./KeyWordsToValueView.vue?vue&type=script&lang=ts"
export * from "./KeyWordsToValueView.vue?vue&type=script&lang=ts"

import "./KeyWordsToValueView.vue?vue&type=style&index=0&id=2e026768&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e026768"]])

export default __exports__